import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { updateMarkupAction, deleteMarkupAction } from 'actions/markupActions'
import { notificationAction } from 'actions/notificationActions'
import Slider from 'rc-slider'
import { DEFAULT_LABEL_SIZES, DEFAULT_LABEL_MARKS } from 'helpers/globals'
import { FillPicker, BorderPicker } from '../ColorPicker'

const mapStateToProps = ({ map: { markups }, currentEntity: { id } }) => {
  const currentLabel = markups.find(m => m.id === id)
  return { currentLabel }
}

const convertToIndex = (size) => {
  const index = DEFAULT_LABEL_SIZES.indexOf(size)
  return index === -1 ? null : index + 1
}

const initialState = { showFillPicker: false, showBorderPicker: false }

class LabelDetails extends React.Component {
  state = { showFillPicker: false, showBorderPicker: false }

  setHexValue = (value, key, close = true) => {
    const { updateMarkupAction, currentLabel } = this.props
    updateMarkupAction(currentLabel.id, { [key]: value })
    if (close) this.setState(initialState)
  }

  toggle = key => {
    if (this.state[key]) this.setState(initialState)
    else this.setState({ ...initialState, [key]: true })
  }

  renderBody() {
    const { setHexValue, state: { showFillPicker, showBorderPicker }, props: { currentLabel: { id, text, overlay, size, fillColor, strokeColor },
      updateMarkupAction, classes } } = this

    if (showFillPicker) return <FillPicker { ...{ fillColor, setHexValue } } />
    if (showBorderPicker) return <BorderPicker { ...{ strokeColor, setHexValue, labelText: 'Font Color' } } />

    return (
      <div>
        <div className={classes.row}>
          <span>Text</span>
          <input
            type='text'
            className={classes.labelTextInput}
            onChange={({ target: { value } }) => {
              updateMarkupAction(id, { text: value })
              overlay.text = value
              overlay.spanElement.textContent = value
            }}
            value={text || ''}
          />
        </div>
        <div className={classes.row}>
          <span>Size</span>
          <div className={classes.sliderContainer}>
            <Slider
              min={1}
              max={DEFAULT_LABEL_SIZES.length}
              value={convertToIndex(size) || Math.ceil(DEFAULT_LABEL_SIZES.length / 2)}
              onChange={size => {
                updateMarkupAction(id, { size: DEFAULT_LABEL_SIZES[size - 1] })
                overlay.changeSize(DEFAULT_LABEL_SIZES[size - 1])
              }}
              marks={DEFAULT_LABEL_MARKS}
              step={null}
            />
          </div>
        </div>
      </div>
    )
  }

  render() {
    const { toggle, props: { currentLabel, updateMarkupAction, deleteMarkupAction, notificationAction, classes } } = this

    if (!currentLabel) return null

    const { id, locked, overlay, fillColor, strokeColor } = currentLabel

    return (
      <div className={classes.labelDetails}>
        <div className={classes.header}>
          Edit Label
        </div>
        <div className={classes.buttonsContainer}>
          <div
            onClick={_ => {
              if (locked) notificationAction('Cannot delete locked label')
              else {
                overlay.setMap(null)
                deleteMarkupAction(id)
              }
            }}
            className={classes.deleteButton}
          >
            <FontAwesomeIcon icon={['far', 'trash-alt']} />
          </div>
          <div className={classes.colorButton} onClick={_ => toggle('showFillPicker')} style={{ color: fillColor === '#0000' ? 'white' : fillColor }}>
            <FontAwesomeIcon icon='fill' className={classes.colorIcon} />
          </div>
          <div className={classes.colorButton} onClick={_ => toggle('showBorderPicker')} style={{ color: strokeColor === '#0000' ? 'white' : strokeColor }}>
            <FontAwesomeIcon icon='font' className={classes.colorIcon} />
          </div>
          <div onClick={_ => overlay.map.fitBounds(overlay.rectangle.getBounds())}>
            <FontAwesomeIcon icon='map-marker-alt' />
          </div>
          <div onClick={_ => updateMarkupAction(id, { locked: !locked })}>
            <FontAwesomeIcon icon={locked ? 'lock' : 'unlock'} />
          </div>
        </div>
        { this.renderBody() }
      </div>
    )
  }
}

export default connect(mapStateToProps, { updateMarkupAction, deleteMarkupAction, notificationAction })(injectSheet(style)(LabelDetails))



// WEBPACK FOOTER //
// ./src/components/BottomBar/LabelDetails/index.js